const templates = require('./templates');

class InfoLocalization {


  constructor() {
    this.path = this.detectPath();
    this.selectMain = document.querySelectorAll('[data-main-diff]');
    this.selectFooter = document.querySelectorAll('[data-footer-diff]');
    this.mainInfo = this.checkInfo(this.path);
    this.footerInfo = this.checkInfo('footer');
  }

  init() {
    if ((this.mainInfo || this.footerInfo) && (this.selectMain || this.selectFooter)) {
      this.getLocation();
    }
  }

  detectPath() {
    let path = window.location.pathname.replace(/\/+$/, '');
    path = path[0] === '/' ? path.substr(1) : path;
    path = path.split('-');
    path = path.map((e, i) => {
      if (i > 0) {
        return e.charAt(0).toUpperCase() + e.slice(1)
      } else {
        return e
      }
    });
    return path.join('');
  }

  render(version) {
    this.version = version;
    this.inject(this.selectMain, this.mainInfo, "mainDiff");
    this.inject(this.selectFooter, this.footerInfo, "footerDiff");
  }

  inject(targets, info, dataName) {
    if (targets && info) {
      targets.forEach(e => {
        try {
          const html = info[this.version][e.dataset[dataName]];
          if (html === "") {
            e.remove();
          } else {
            e.innerHTML = info[this.version][e.dataset[dataName]];
          }
        } catch {
          log('render error', 'INFO LOCALIZATION');
        }
      });
    }
  }

  getLocation() {
    if (window.countryCode) {
      this.selectVersion(window.countryCode);
    } else {
      window.setTimeout(() => {
        this.getLocation();
      }, 100);
    }
  }

  selectVersion(code) {
    const LOCALIZATION_SWITCH = $LOCALIZATION_SWITCH;
    log(code, 'LOCALIZATION CODE:');
    this.render( LOCALIZATION_SWITCH ? (templates.group.includes(code) ? 'usa' : 'eu') : 'usa');
  }

  checkInfo(path) {
    return templates[path];
  }
}

module.exports = InfoLocalization;